module.exports = __webpack_public_path__ + "static/media/7-ANTI-POLICE-BRUTALITY-2.94b4f810.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/7-ANTI-POLICE-BRUTALITY-2.jpg
// module id = 143
// module chunks = 0